import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { supabase } from '../webSupabaseClient';

// DÜZELTME: 'closeModal' yerine 'onSuccess' prop'u alıyoruz.
function UpdatePasswordForm({ onSuccess }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password: password });
      if (error) throw error;
      
      toast.success('Şifreniz başarıyla güncellendi! Şimdi yeni şifrenizle giriş yapabilirsiniz.');
      
      // Şifre güncellendikten sonra çıkış yaptırarak temiz bir başlangıç sağlıyoruz.
      await supabase.auth.signOut();
      
      // DÜZELTME: Başarılı olunca onSuccess fonksiyonunu çağırıyoruz.
      if (onSuccess) {
        onSuccess();
      }

    } catch (error) {
      toast.error(error.message || 'Şifre güncellenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h3 className="text-xl font-bold text-center mb-4">Yeni Şifrenizi Belirleyin</h3>
      <form onSubmit={handlePasswordReset} className="space-y-4">
        <div>
          <label htmlFor="new-password"className="block text-sm font-medium text-gray-700">Yeni Şifre</label>
          <input
            id="new-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength="6"
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-brand-green focus:border-brand-green"
            placeholder="En az 6 karakter"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brand-green hover:bg-brand-green-light disabled:bg-gray-400"
        >
          {loading ? 'Kaydediliyor...' : 'Yeni Şifreyi Kaydet'}
        </button>
      </form>
    </div>
  );
}

export default UpdatePasswordForm;